export default __webpack_public_path__ + "static/media/17-Windswept.589e3a98.jpeg";